import { IModelEntity } from '@pit/core';
import { IDtoShipmentProcess } from './dto.shipment.process.interface';
import { IDtoMandator } from './dto.mandator.interface';
import { IDtoAddressee } from './dto.addressee.interface';
import { IDtoCustomer } from './dto.customer.interface';
import { IDtoDevice } from './dto.device.interface';

export interface IDtoShipment extends IModelEntity {

    depotNumber?: string;
    deviceId?: string;
    externalShipmentId?: string;
    isMarkedAsTrackable?: boolean;
    shipmentDate?: Date;
    shipmentNumbers?: string[];

    productTypeCode?: string;
    productTypeDescription?: string;

    addressee?: IDtoAddressee;
    customer?: IDtoCustomer;
    device?: IDtoDevice;
    mandator?: IDtoMandator;
    processes?: IDtoShipmentProcess[];

    fullAddress?: string;
    isFinished?: boolean;
    isOpen?: boolean;
    isSyncedToServer?: boolean;
    currentProcess?: IDtoShipmentProcess;
    processStateDescription?: string;

    userDescription?: string;
    userName?: string;

    getHasShipmentNumber?: (shipmentNumber: string) => boolean;

}
